import {
  ActivitiesCallsFieldNames,
  AutoLockFormsLevelType,
  FormNames,
} from '../autoLockForms.constants';

const formFields = [
  {
    name: ActivitiesCallsFieldNames.CALL_OUTCOME,
    label: 'Call outcome',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'callNotes',
    label: 'Call notes',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const activitiesCallsForm = {
  name: FormNames.ACTIVITIES_CALLS,
  label: 'Calls',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
